/**
 * The two gateways come back with different query strings:
 *   EPS    → /payment/{success|fail|cancel}?transactionId=…&status=…
 *   Stripe → /payment/success?transactionID=…        (no status)
 * so both spellings are accepted here.
 */
export const getPaymentQueryData = (searchParams) => {
  const paySystemName = searchParams.get("paySystemName");
  const status = searchParams.get("status");

  const rawTransactionID =
    searchParams.get("transactionID") ||
    searchParams.get("transactionId") ||
    searchParams.get("trnsID") ||
    searchParams.get("transId");

  // Some gateways append extra query fragments in the value itself.
  const transactionID = rawTransactionID?.split("?")[0];

  return {
    paySystemName,
    status,
    rawTransactionID,
    transactionID,
    // Stripe hands back no status, so the app confirms the session itself.
    needsVerification: !!transactionID && !status,
  };
};
